import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  //public
  {
    path: "/recuperar_contrasena",
    name: "password_recover",
    component: () => import("../views/general/passwordRecover.vue"),
    meta: { title: "SM INFO" },
  },
  {
    path: "/restablecer_contrasena/:id_encrypt",
    name: "password_reset",
    component: () => import("../views/general/passwordReset.vue"),
    meta: { title: "SM INFO" },
    props: true,
  },
  {
    path: "/formulario/:doctor_email_type_id/medico/:doctor_id/servicio/:rs_service_id",
    name: "doctor_email.form",
    component: () => import("../views/public/DoctorEmailForm.vue"),
    meta: {
      title: "Médico | Formulario F",
    },
    props: true,
  },
  {
    path: "/medico/folio",
    name: "doctor_folio_search",
    component: () => import("@/views/general/DoctorFolioSearch.vue"),
    meta: {
      title: "Cargar factura por folio",
    },
  },
  {
    path: "/hospital/peticiones",
    name: "provider_rha_demand_search",
    component: () => import("@/views/general/ProviderRhaDemandSearch.vue"),
    meta: {
      title: "Peticiones por folio",
    },
  },

  //employee
  {
    path: "/empleado/informacion",
    name: "employee.show",
    component: () => import("../views/employee/Show.vue"),
    meta: {
      title: "Mi información",
      title_en: "My information",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 3,
    },
  },
  {
    path: "/empleado/informacion/editar",
    name: "employee.form",
    component: () => import("../views/employee/Form.vue"),
    meta: {
      title: "Editar información",
      title_en: "Edit information",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 3,
    },
  },
  //brand
  {
    path: "/concentrador/facturacion/documentos/:bill_document_request_id",
    name: "brand.bill_document_request",
    component: () => import("../views/brand/BillDocumentRequest.vue"),
    meta: {
      title: "Facturación | Documentos",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 20,
    },
  },
  {
    path: "/concentrador/facturacion",
    name: "brand.bills",
    component: () => import("../views/brand/Bills.vue"),
    meta: {
      title: "Facturación",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 20,
    },
  },
  {
    path: "/concentrador/facturacion/:rha_id/:rs_service_id/:rha_bill_id?/:rs_service_bill_id?",
    name: "brand.bills_upload",
    component: () => import("../views/brand/BillsUpload.vue"),
    meta: {
      title: "Facturación | Cargar",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 20,
    },
  },
  {
    path: "/concentrador/facturacion/nota_credito/:rha_id/:rs_service_id",
    name: "brand.bill_credit_note_after",
    component: () => import("../views/brand/BillCreditNoteAfter.vue"),
    meta: {
      title: "Facturación | Nota de crédito",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 20,
    },
  },
  //provider_new
  {
    path: "/proveedor/facturacion/documentos/:bill_document_request_id",
    name: "provider_new.bill_document_request",
    component: () => import("../views/provider_new/BillDocumentRequest.vue"),
    meta: {
      title: "Facturación | Documentos",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 19,
    },
  },
  {
    path: "/proveedor/ingresos",
    name: "provider_new.rhas",
    component: () => import("../views/provider_new/Rhas.vue"),
    meta: {
      title: "Reporte Ingreso Hospitalario, Urgencias y Servicios Externos",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 19,
    },
  },
  {
    path: "/proveedor/facturacion",
    name: "provider_new.bills",
    component: () => import("../views/provider_new/Bills.vue"),
    meta: {
      title: "Facturación",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 19,
    },
  },
  {
    path: "/proveedor/facturacion/:rha_id/:rs_service_id/:rha_bill_id?/:rs_service_bill_id?",
    name: "provider_new.bills_upload",
    component: () => import("../views/provider_new/BillsUpload.vue"),
    meta: {
      title: "Facturación | Cargar",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 19,
    },
  },
  {
    path: "/proveedor/facturacion/nota_credito/:rha_id/:rs_service_id",
    name: "provider_new.bill_credit_note_after",
    component: () => import("../views/provider_new/BillCreditNoteAfter.vue"),
    meta: {
      title: "Facturación | Nota de crédito",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 19,
    },
  },
  //president
  {
    path: "/presidente/servicios",
    name: "president.services",
    component: () => import("../views/president/Services.vue"),
    meta: {
      title: "Servicios",
      title_en: "Services",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 16,
    },
  },
  //vendor
  {
    path: "/proveedoradmin/servicios",
    name: "vendor.payments",
    component: () => import("../views/vendor/Payments.vue"),
    meta: {
      title: "Pagos",
      title_en: "Payments",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 21,
    },
  },
  //pharmacy
  {
    path: "/farmacia/servicios/documentacion/multiple",
    name: "pharmacy.services_multi_doc",
    component: () => import("../views/pharmacy/ServicesMultiDoc.vue"),
    meta: {
      title: "Servicios | Documentación multiple",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 13,
    },
  },
  {
    path: "/farmacia/servicios/documentacion/multiple-v2",
    name: "pharmacy.services_multi_doc_v2",
    component: () => import("../views/pharmacy/ServicesMultiDocV2.vue"),
    meta: {
      title: "Servicios | Documentación múltiple",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 13,
    },
  },
  {
    path: "/farmacia/servicios",
    name: "pharmacy.services",
    component: () => import("../views/provider/Services.vue"),
    meta: {
      title: "Servicios",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 13,
    },
  },
  {
    path: "/farmacia/servicios/documentacion/:rs_service_id",
    name: "pharmacy.services_documentation",
    component: () => import("../views/provider/ServicesDocumentation.vue"),
    meta: {
      title: "Servicios | Documentación",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 13,
    },
    props: true,
  },
  //provider
  {
    path: "/proveedor/servicios",
    name: "provider.services",
    component: () => import("../views/provider/Services.vue"),
    meta: {
      title: "Servicios",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 4,
    },
  },
  {
    path: "/proveedor/servicios/documentacion/:rs_service_id",
    name: "provider.services_documentation",
    component: () => import("../views/provider/ServicesDocumentation.vue"),
    meta: {
      title: "Servicios | Documentación",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 4,
    },
    props: true,
  },
  //insured
  {
    path: "/asegurado/servicios",
    name: "insured.services",
    component: () => import("../views/insured/Services.vue"),
    meta: {
      title: "Servicios",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 7,
    },
  },
  {
    path: "/asegurado/ingresos",
    name: "insured.rhas",
    component: () => import("../views/insured/Rhas.vue"),
    meta: {
      title: "Ingresos",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 7,
    },
  },
  //doctor
  {
    path: "/medico/preguntas_comentarios",
    name: "doctor.comments",
    component: () => import("../views/doctor/Comments.vue"),
    meta: {
      title: "Preguntas o comentarios",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 5,
    },
  },
  {
    path: "/medico/servicios",
    name: "doctor.services",
    component: () => import("../views/doctor/Services.vue"),
    meta: {
      title: "Consultas | Solicitud de cobro",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 5,
    },
  },
  {
    path: "/medico/servicios/documentacion/:rs_service_id",
    name: "doctor.services_documentation",
    component: () => import("../views/doctor/ServicesDocumentation.vue"),
    meta: {
      title: "Consultas médica | Documentación",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 5,
    },
    props: true,
  },
  {
    path: "/medico/edicion/informacion",
    name: "doctor.form_update",
    component: () => import("../views/doctor/FormUpdate.vue"),
    meta: {
      title: "Edición de información",
      requiresAuth: true,
      permission: store.getters.getLogin.role_id == 5,
    },
  },
  //user_profile
  {
    path: "/perfil_usuario",
    name: "user.profile",
    component: () => import("../views/user/Profile.vue"),
    meta: {
      title: "Mi perfil",
      title_en: "Profile",
      requiresAuth: true,
      permission: true,
    },
  },
  //general
  {
    path: "/",
    name: "main",
    component: () => import("../views/general/Main.vue"),
    meta: { title: "SM INFO" },
  },
  {
    path: "/inicio_sesion",
    name: "login",
    component: () => import("../views/general/Login.vue"),
    meta: { title: "SM INFO" },
  },
  {
    path: "/inicio",
    name: "home",
    component: () => import("../views/general/Home.vue"),
    meta: { title: "SM INFO", requiresAuth: true, permission: true },
  },
  {
    path: "/acceso_denegado",
    name: "unauthorized",
    component: () => import("../views/general/Unauthorized.vue"),
    meta: { title: "Acceso denegado", requiresAuth: true, permission: true },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not_found",
    component: () => import("../views/general/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// function setPermission(interface_atr, permission) {
//   if (store.getters.getLogin.permissions) {
//     if (store.getters.getLogin.permissions[interface_atr]) {
//       return store.getters.getLogin.permissions[interface_atr][permission]
//     }
//     return false
//   }
//   return false
// }

router.beforeEach((to, from, next) => {
  let auth = store.getters.getLogin.auth;

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (to.matched.some((record) => record.meta.permission)) {
      if (auth) {
        next();
      } else {
        next({ name: "login" });
      }
    } else {
      next({ name: "unauthorized" });
    }
  } else {
    if (auth) {
      next({ name: "home" });
    } else {
      next();
    }
  }

  document.title = to.meta.title;
});

export default router;
